export const USER_PROFILE_SET_DATA = 'USER_PROFILE_SET_DATA';
export const USER_PROFILE_SET_LOADING = 'USER_PROFILE_SET_LOADING';
